import { createFileRoute } from "@tanstack/react-router";
import Organizations from "@/features-root-user/organization";
import { organizationsQueryOptions } from "@/features-root-user/service/organization";
import { LoadingScreen } from "@/components/ui/loading-screen";

export const Route = createFileRoute("/_root/root-user/organization/")({
  loader: ({ context: { queryClient } }) => {
    queryClient.ensureQueryData(organizationsQueryOptions);
  },
  pendingComponent: () => <LoadingScreen text="Loading..." />,
  component: Organizations,
});
